module.exports = __webpack_public_path__ + "static/media/goodsOwnerCode.f11b81dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/images/goodsOwnerCode.png
// module id = 164
// module chunks = 0